import { postRequest, postFormRequest } from '@/helpers/request';

export async function getIBSummary(payload = {}) {
  const data = await postRequest('/ib_portal/summary/', payload);
  return data;
}

export async function getIBToday(payload = {}) {
  const data = await postRequest('/ib_portal/today/', payload);
  return data;
}

export async function getIBRollCandidates(payload = {}) {
  const data = await postRequest('/ib_portal/roll_candidates/', payload);
  return data;
}

export async function getIBClientBook(payload = {}) {
  const data = await postRequest('/ib_portal/client_book/', payload);
  return data;
}

export async function getIBClientDetail(payload = {}) {
  const data = await postRequest('/ib_portal/client_detail/', payload);
  return data;
}

export async function getIBHedgeIntents(payload = {}) {
  const data = await postRequest('/ib_portal/hedge_intents/', payload);
  return data;
}

export async function saveIBClientNote(payload = {}) {
  const data = await postRequest('/ib_portal/client_note/', payload);
  return data;
}

export async function getIBClients(payload = {}) {
  const data = await postRequest('/ib_portal/clients/', payload);
  return data;
}

export async function getIBBroadcasts(payload = {}) {
  const data = await postRequest('/ib_portal/broadcasts/', payload);
  return data;
}

export async function sendIBBroadcast(payload = {}) {
  const data = await postRequest('/ib_portal/broadcasts/send/', payload);
  return data;
}

export async function getProducerAdvisor(payload = {}) {
  const data = await postRequest('/producer/advisor/', payload);
  return data;
}

export async function requestProducerAdvisor(payload) {
  const data = await postRequest('/producer/advisor/request/', payload);
  return data;
}

export async function markBroadcastEngagement(payload = {}) {
  const data = await postRequest('/producer/broadcast_engagement/', payload);
  return data;
}

export async function getIBMessageGroups(payload = {}) {
  const data = await postRequest('/ib_portal/messages/groups/', payload);
  return data;
}

export async function sendIBMessage(payload) {
  const { data } = await postFormRequest('/ib_portal/messages/send/', payload);
  return data;
}

export async function saveIBAdvisorLogo(formData) {
  const data = await postFormRequest('/ib_portal/logo/save/', formData);
  return data;
}

export async function removeIBAdvisorLogo(payload = {}) {
  const data = await postRequest('/ib_portal/logo/remove/', payload);
  return data;
}

export async function getIBPodcastEpisodes(payload = {}) {
  const data = await postRequest('/ib_portal/podcast/episodes/', payload);
  return data;
}

export async function uploadIBPodcastEpisode(formData) {
  const data = await postFormRequest('/ib_portal/podcast/upload/', formData);
  return data;
}

export async function createIBPodcastEpisodeFromYouTube(payload) {
  const data = await postRequest('/ib_portal/podcast/create_from_youtube/', payload);
  return data;
}

export async function setIBPodcastEpisodeStatus(payload) {
  const data = await postRequest('/ib_portal/podcast/set_status/', payload);
  return data;
}

export async function deleteIBPodcastEpisode(payload) {
  const data = await postRequest('/ib_portal/podcast/delete/', payload);
  return data;
}

export async function updateIBPodcastEpisode(payload) {
  const data = await postRequest('/ib_portal/podcast/update/', payload);
  return data;
}

export async function getIBPodcastAudienceOptions(payload = {}) {
  const data = await postRequest('/ib_portal/podcast/audience_options/', payload);
  return data;
}

export async function getClientPodcastFeed(payload = {}) {
  const data = await postRequest('/producer/podcast/episodes/', payload);
  return data;
}

export async function trackPodcastView(payload) {
  const data = await postRequest('/producer/podcast/track_view/', payload);
  return data;
}

export async function trackPodcastProgress(payload) {
  const data = await postRequest('/producer/podcast/track_progress/', payload);
  return data;
}

export async function getIBPulseFeed(payload = {}) {
  const data = await postRequest('/ib_portal/pulse/feed/', payload);
  return data;
}

export async function setIBPulseFilter(payload) {
  const data = await postRequest('/ib_portal/pulse/filter/', payload);
  return data;
}

export async function recordIBPulseEngagement(payload) {
  const data = await postRequest('/ib_portal/pulse/engagement/', payload);
  return data;
}

// Records that this advisor opened a pulse event, for the compliance audit log
// (Story 9, AC9.2). Deliberately not the engagement endpoint: that one reports
// lossy upstream counters and swallows its failures, while this one owns a record
// that must not go missing.
export async function recordIBPulseView(eventId) {
  const data = await postRequest('/ib_portal/pulse/view/', { event_id: eventId });
  return data;
}

export async function setIBPulseDismissed(payload) {
  const data = await postRequest('/ib_portal/pulse/dismiss/', payload);
  return data;
}

export async function setIBPulseUpcomingCollapsed(payload) {
  const data = await postRequest('/ib_portal/pulse/upcoming/collapse/', payload);
  return data;
}
